import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

import { GuidDictionaryItem } from '../../../../api/api-reference';

@Component({
  selector: 'app-multi-select-dropdown-search',
  standalone: true,
  imports: [FormsModule, HttpClientModule, TranslateModule, CommonModule],
  templateUrl: './multi-select-dropdown-search.component.html',
  styleUrl: './multi-select-dropdown-search.component.scss',
})
export class MultiSelectDropdownSearchComponent implements OnInit, OnChanges {
  searchText: string = '';
  allItems: GuidDictionaryItem[] = [];
  filteredItems: GuidDictionaryItem[] = [];
  selectedItems: GuidDictionaryItem[] = [];
  result: string[] | undefined = [];

  @Input() selected: string[] = [];
  @Input() placeholder: string = 'SEARCHBY_METERMAKE';
  @Input() fetchItems!: () => Observable<GuidDictionaryItem[]>;
  @Output() listEmitted = new EventEmitter<string[]>();

  constructor(
    private toastr: ToastrService,
    private elementRef: ElementRef,
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.filteredItems = [];
      this.searchText = '';
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fetchItems'] && !changes['fetchItems'].firstChange) {
      this.loadItems();
      return;
    }

    if (changes['selected'] && !changes['selected'].firstChange && this.allItems.length > 0) {
      this.selectedItems = this.allItems.filter((item) =>
        this.selected.includes(item.value!),
      );
      this.filteredItems = [];
      this.searchText = '';
    }
  }

  ngOnInit(): void {
    this.loadItems();
  }

  private loadItems(): void {
    this.fetchItems().subscribe({
      next: (response) => {
        this.allItems = response ?? [];

        this.selectedItems = this.selected && this.selected.length > 0
          ? this.allItems.filter((item) => this.selected.includes(item.value!))
          : [];

        this.filteredItems = this.allItems.filter(
          (item) =>
            !this.selectedItems.some((s) => s.value === item.value),
        );
      },
      error: (err) => {
        this.toastr.error(err);
      },
    });
  }

  search() {
    if (this.searchText == '') {
      this.filteredItems = [];
      return;
    }
    this.filteredItems = this.allItems.filter((item) =>
      item.name?.toUpperCase().includes(this.searchText.toUpperCase()),
    );

    for (const selected of this.selectedItems) {
      this.filteredItems = this.filteredItems.filter(
        (item) => item.value != selected.value,
      );
    }
  }

  selectItem(item: GuidDictionaryItem): void {
    this.selectedItems.push(item);
    this.filteredItems = [];
    this.searchText = '';

    this.result = this.selectedItems.map((i) => i.value!);
    this.listEmitted.emit(this.result);
  }

  removeItem(item: GuidDictionaryItem): void {
    this.selectedItems = this.selectedItems.filter(
      (i) => i.value != item.value,
    );

    this.result = this.selectedItems.map((i) => i.value!);
    this.listEmitted.emit(this.result);
  }
}
